import React, { FunctionComponent, ReactNode } from "react";
import { snakeCase } from "lodash";
import clsx from "clsx";
import Typography from "../../../../../components/typography/Typography";
import { LAYOUT_TYPE } from "../reanalyze-form-input/ReanalyzeFormInput";
import Time from "../../../../../components/Time";
import { Icon } from "../../../../../components";
import { Sizes } from "../../../../../components/Icon";

type ReanalyzeFormInputLabelProps = {
  name: string;
  labelIcon: string;
  labelIconSize: Sizes;
  layout: string;
  disabled?: boolean;
  label: ReactNode;
  help?: string;
  helpImportant?: string | null;
  timestamp?: string;
};

const ReanalyzeFormInputLabel: FunctionComponent<
  ReanalyzeFormInputLabelProps
> = props => (
  <div
    className={clsx(
      "d-flex align-items-center gap-5 cursor-pointer",
      props.disabled ? "cursor-not-allowed" : "cursor-pointer"
    )}
  >
    <Icon
      name={props.labelIcon}
      size={props.labelIconSize}
      dimensions={props.labelIconSize}
    />
    <div
      className={clsx(
        "d-flex",
        props.layout === LAYOUT_TYPE.ROW
          ? "align-items-center"
          : "align-items-baseline",
        props.layout === LAYOUT_TYPE.ROW && "gap-10",
        props.layout === LAYOUT_TYPE.ROW ? "flex-row" : "flex-column"
      )}
      style={{ maxWidth: 426 }}
    >
      <Typography
        variant={props.layout === LAYOUT_TYPE.ROW ? "h5" : "body1"}
        className={clsx(
          {
            "text-color-disabled":
              props.disabled && props.layout === LAYOUT_TYPE.COL
          },
          "text-nowrap"
        )}
      >
        {props.label}
      </Typography>
      {props.help && (
        <Typography
          variant={"subtitle6"}
          className={clsx(
            "fst-italic text-nowrap",
            props.disabled ? "text-color-disabled" : "text-color-red"
          )}
          data-testid={`reanalyze_form_help_text_${snakeCase(props.name)}`}
        >
          {props.help}
        </Typography>
      )}
      {props.helpImportant && (
        <>
          {props.layout === LAYOUT_TYPE.ROW && (
            <Typography variant={"h5"}>|</Typography>
          )}
          <span
            className={clsx(
              {
                "text-color-disabled":
                  props.disabled && props.layout === LAYOUT_TYPE.COL
              },
              "overflow-ellipsis"
            )}
            data-testid={`reanalyze_form_help_text_important_${snakeCase(
              props.name
            )}`}
          >
            {props.helpImportant}
          </span>
        </>
      )}
      {props.timestamp && (
        <>
          {props.layout === LAYOUT_TYPE.ROW && (
            <Typography variant={"h5"}>|</Typography>
          )}
          <span
            className="reanalyze-form-help-text"
            data-testid={`reanalyze_form_timestamp_${snakeCase(props.name)}`}
          >
            <Time
              className={clsx({
                "text-color-disabled":
                  props.disabled && props.layout === LAYOUT_TYPE.COL
              })}
              time={props.timestamp}
            />
          </span>
        </>
      )}
    </div>
  </div>
);

export default ReanalyzeFormInputLabel;
